import React, { useEffect, useState } from "react";
import { Box, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BrandLogo } from "components/Flowstate";
import { palette } from "../palette";
import { useVisitor } from "../useVisitor";

const NAV = [
  { label: "How it works", href: "#how-it-works" },
  { label: "What we cover", href: "#what-we-cover" },
  { label: "Why 50", href: "#the-fifty" },
  { label: "FAQ", href: "#faq" },
];

export const SiteHeader = ({ onRegister }) => {
  const navigate = useNavigate();
  const [lifted, setLifted] = useState(false);
  const { known } = useVisitor();

  // Only show the divider and blur once the page has actually moved.
  useEffect(() => {
    const onScroll = () => setLifted(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Box
      component="header"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 20,
        backgroundColor: lifted ? "rgba(251,250,248,0.85)" : "transparent",
        backdropFilter: lifted ? "saturate(180%) blur(12px)" : "none",
        borderBottom: `1px solid ${lifted ? palette.border : "transparent"}`,
        transition: "background-color 0.25s ease, border-color 0.25s ease",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            py: 2,
          }}
        >
          <BrandLogo size="medium" isLight to="/flowstate" />

          <Box
            component="nav"
            aria-label="Main"
            sx={{ display: { xs: "none", md: "flex" }, gap: 3.5 }}
          >
            {NAV.map((item) => (
              <Box
                key={item.href}
                component="a"
                href={item.href}
                sx={{
                  color: palette.textMuted,
                  fontSize: 15,
                  fontWeight: 500,
                  textDecoration: "none",
                  "&:hover": { color: palette.text },
                }}
              >
                {item.label}
              </Box>
            ))}
          </Box>

          {/* People who already have an account get a door labelled for them;
              everyone else gets one obvious next step. Nothing on the page ever
              asks the visitor which of the two they are. */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {known ? (
              <Button
                onClick={() => navigate("/login")}
                disableElevation
                sx={{
                  px: 2.5,
                  py: 1,
                  borderRadius: "999px",
                  background: palette.ctaGradient,
                  color: "#ffffff",
                  fontSize: 14.5,
                  fontWeight: 600,
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  "&:hover": { background: palette.primaryHover },
                }}
              >
                Go to dashboard
              </Button>
            ) : (
              <>
                <Button
                  onClick={() => navigate("/login")}
                  disableElevation
                  sx={{
                    display: { xs: "none", sm: "inline-flex" },
                    minWidth: 0,
                    px: 1.5,
                    color: palette.textFaint,
                    fontSize: 14.5,
                    fontWeight: 500,
                    textTransform: "none",
                    background: "none",
                    "&:hover": { background: "none", color: palette.text },
                  }}
                >
                  Sign in
                </Button>
                <Button
                  onClick={onRegister}
                  disableElevation
                  sx={{
                    px: 2.5,
                    py: 1,
                    borderRadius: "999px",
                    background: palette.ctaGradient,
                    color: "#ffffff",
                    fontSize: 14.5,
                    fontWeight: 600,
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    "&:hover": { background: palette.primaryHover },
                  }}
                >
                  Talk to us
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SiteHeader;
